module.exports = __webpack_public_path__ + "static/media/sports-for-business.7e3dde03.png";